import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import './EnglishSection.css';
import GrammarTable from '../GrammarTable/GrammarTable';
import QuizSection from '../QuizSection/QuizSection';

const EnglishSection = () => {
  const { getText } = useLanguage();

  return (
    <div className="english-section">
      <header className="english-header">
        <h1>📚 {getText('english.title')} 📚</h1>
        <p className="subtitle">{getText('english.subtitle')}</p>
        <div className="header-decoration">
          <span className="decoration-item">🎯</span>
          <span className="decoration-item">📖</span>
          <span className="decoration-item">✨</span>
        </div>
      </header>
      
      <main className="english-content">
        <GrammarTable />
        <QuizSection />
      </main>
      
      <footer className="english-footer">
        <p>🌟 {getText('english.description')} 🌟</p>
      </footer>
    </div>
  );
};

export default EnglishSection;
